import styled from 'styled-components';

/** Above mobile sidebar (Layout LeftPanel z-index 100000) and desktop rail (1000). */
export const overlayZIndex = 100100;
export const overlayContentZIndex = 100101;

export const Bg = styled.div`
  width: 100vw;
  height: 100svh;
  position: fixed;
  top: 0;
  left: 0;
  background: black;
  opacity: 0.01;
  z-index: ${overlayZIndex};
  transition: opacity ease-in 250ms;
`;

export const Content = styled.div`
  position: fixed;
  right: 50%;
  bottom: calc(0% - 100svh);
  transform: translate(50%, 0%);
  z-index: ${overlayContentZIndex};
  opacity: 0;
  /* Transition applied in JS for open only; leaving transition:all causes Y flash when content height changes */
`;
